import { grey } from '@mui/material/colors';

const gapX = '.25rem';

export const seriesDimensionTextSX = {
	paddingY: '2px',
	width: { xs: `calc((100% - (2 - 1) * ${gapX}) / 2)`, sm: `calc((100% - (3 - 1) * ${gapX}) / 3)` },
	lineHeight: 'normal',
	fontFamily: 'Roboto, sans-serif',
	fontSize: '0.8rem',
	fontWeight: '400',
	color: 'black.main',
	textAlign: 'center',
	background: grey[200],
};

export const seriesDimensionListSX = {
	display: 'flex',
	flexWrap: 'wrap',
	gap: `${gapX} .1875rem`,
};
